import { render, staticRenderFns } from "./DemoContent.vue?vue&type=template&id=0c97b152&"
import script from "./DemoContent.vue?vue&type=script&lang=js&"
export * from "./DemoContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports